.scrollArea {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.fillScroll {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.table {
  width: 100%;
  min-width: 100%;
}

.headerCell {
  min-width: 0;
}

.headerFilter {
  width: 100%;
  min-width: 0;
}

/* Compact NativeSelect / legacy <select> when used as column headerFilter */
.headerFilter :global(.mantine-NativeSelect-root),
.headerFilter :global(.mantine-InputWrapper-root) {
  width: 100%;
}

.headerFilter :global(.mantine-NativeSelect-input),
.headerFilter :global(.mantine-Input-input),
.headerFilter :global(select) {
  font-size: var(--mantine-font-size-xs);
  min-height: 1.75rem;
  height: 1.75rem;
}

.stickyRight {
  background: var(--mantine-color-body);
  /* Keep actions visible: do not force width:1% (clips multi-button cells). */
  vertical-align: middle;
}

.table tbody tr[data-striped]:nth-of-type(odd) .stickyRight,
.table[data-striped='odd'] tbody tr:nth-of-type(odd) .stickyRight {
  background: var(--mantine-color-gray-0);
}

.table tbody tr:hover .stickyRight {
  background: var(--mantine-color-gray-0);
}
